// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace CiState {
	export type CiState = 'NO_ORDER' | 'ORDER' | 'NO_ORDER_BUT_SETTINGS';
	export const CiState = {
		NoOrder: 'NO_ORDER' as CiState,
		Order: 'ORDER' as CiState,
		NoOrderButSettings: 'NO_ORDER_BUT_SETTINGS' as CiState,
	};
}
